import React from 'react';

export default ( { className, fill, ...props } ) => (
    <svg width="24" height="24" className={ className } { ...props } viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M11 10.03H13V16.97H11V10.03ZM12 7.02C11.45 7.02 11 7.47 11 8.02C11 8.57 11.45 9.02 12 9.02C12.55 9.02 13 8.57 13 8.02C13 7.47 12.55 7.02 12 7.02ZM22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12ZM20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12Z" fill={ fill || 'currentColor' } />
    </svg>
);
